import React from 'react';

import { Loader, Paper, Select, Stack, Text, Title } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';
import usePipelines from 'hooks/glmFlows/usePipelines';

import { FormValues } from '../types';

interface IKiloGLMPipelineStageSelectProps {
  form: UseFormReturnType<FormValues, (values: FormValues) => FormValues>;
}

const KiloGLMPipelineStageSelect = ({ form }: IKiloGLMPipelineStageSelectProps): JSX.Element => {
  const { data: pipelines = [], isLoading } = usePipelines();

  const selectedPipeline = pipelines.find(p => p.id === form.values.acPipelineId);
  const stageOptions = (selectedPipeline?.stages ?? []).map(s => ({ value: s.id, label: s.name }));

  return (
    <Paper>
      <Stack sx={{ paddingTop: '20px' }}>
        <Title order={3}>Which pipeline and stage?</Title>
        <Text size={15}>
          Pick the Gym Lead Machine pipeline and the stage the contact should be moved to.
        </Text>
        {isLoading ? (
          <Loader size='sm' />
        ) : (
          <>
            <Select
              label='Pipeline'
              placeholder='Select a pipeline'
              data={pipelines.map(p => ({ value: p.id, label: p.name }))}
              value={form.values.acPipelineId}
              onChange={value => {
                form.setFieldValue('acPipelineId', value);
                form.setFieldValue('acStageId', null);
              }}
              searchable
            />
            <Select
              label='Stage'
              placeholder={selectedPipeline ? 'Select a stage' : 'Select a pipeline first'}
              data={stageOptions}
              value={form.values.acStageId}
              onChange={value => form.setFieldValue('acStageId', value)}
              disabled={!selectedPipeline}
              searchable
            />
          </>
        )}
      </Stack>
    </Paper>
  );
};

export default KiloGLMPipelineStageSelect;
